import { Component } from '@angular/core';
import validationEngine from 'devextreme/ui/validation_engine';
import { DevExtremeModule } from 'devextreme-angular';
import * as _ from 'lodash';
import { CdrUnitOfWork } from 'src/app/core/core.module';
import { Dumpster } from 'src/app/core/model/dumpster';
import { TimeType } from 'src/app/core/model/time-type';
import { TonExpense } from 'src/app/core/model/ton-expense';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';

@Component({
    selector: 'app-select-dumpsters-dialog',
    templateUrl: './select-dumpsters-dialog.component.html',
    styleUrls: ['./select-dumpsters-dialog.component.scss'],
    standalone: true,
    imports: [DevExtremeModule]
})
export class SelectDumpstersDialogComponent extends BaseDialogComponent<any> {
    selectedIds: number[];
    dumpsters: Dumpster[];

    constructor(private uow: CdrUnitOfWork) {
        super();
    }

    async ngOnInit() {
        this.dumpsters = this.uow.lookups.dumpsters;
    }

    save = async () => {
        this.hide({ success: true, value: this.selectedIds });
    };

    cancel = async () => {
        this.uow.rollback();
        this.hide({ success: false });
    };
}
